import css from 'styled-jsx/css';

const styles = css.global`#blog-list-categories > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 48px;
  cursor: pointer;
  overflow: hidden;
  overflow-x: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  padding-top: 5px;
  padding-bottom: 5px;
}

#blog-list-categories > div::-webkit-scrollbar {
  display: none;
}

#blog-list-categories > div div {
  border-bottom: 1px solid #444444;
  min-width: 145px;
  height: 38px;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

#blog-list-categories > div div.categories-item-4{
  min-width: 175px;
}
#blog-list-categories > div div.categories-item-5 {
  min-width: 165px;
}

#blog-list-categories > div div:hover,
#blog-list-categories > div div.selected {
  border-bottom: 2px solid #cc0000;
}

#blog-list-categories > div div span {
  color: #444;
  font-family: 'SantanderText';
  font-size: 18px;
  letter-spacing: 0;
  line-height: 28px;
  white-space: nowrap;
}

#blog-list-categories > div div:hover span,
#blog-list-categories > div div.selected span {
  color: #cc0000;
}

#blog-list-title h1 {
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 30px;
}

.vejamaispostagens {
  cursor: pointer;
  box-sizing: border-box;
  height: 48px;
  max-width: 272px;
  width: 100%;
  font-family: 'SantanderText';
  margin: 0 auto 40px;
}


body {
  background: #FBFBFB;
}


@media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
  }`;

export default styles;